export const registryMatchesPopoverText = `Our algorithm compares business names and 
  addresses gathered from various open 
  sources against registry data, using a 
  combination of exact and fuzzy 
  matching techniques.`
